var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKnowViewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35132 0.954102C4.18026 0.954102 1.47218 2.9265 0.375 5.71068C1.47218 8.49486 4.18026 10.4673 7.35132 10.4673C10.5224 10.4673 13.2304 8.49486 14.3276 5.71068C13.2304 2.9265 10.5224 0.954102 7.35132 0.954102ZM7.35132 8.88173C5.60089 8.88173 4.18026 7.4611 4.18026 5.71068C4.18026 3.96026 5.60089 2.53963 7.35132 2.53963C9.10174 2.53963 10.5224 3.96026 10.5224 5.71068C10.5224 7.4611 9.10174 8.88173 7.35132 8.88173ZM7.35132 3.80805C6.29853 3.80805 5.44868 4.65789 5.44868 5.71068C5.44868 6.76347 6.29853 7.61331 7.35132 7.61331C8.40411 7.61331 9.25395 6.76347 9.25395 5.71068C9.25395 4.65789 8.40411 3.80805 7.35132 3.80805Z",
    fill: "#65A0F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowViewsIcon);
export default __webpack_public_path__ + "static/media/know-views-icon.7575bdfae560f679bf6ccbcdf61c440f.svg";
export { ForwardRef as ReactComponent };